import {
  takeLatest, put,
} from 'redux-saga/effects';

import * as giftActions from '../actions';

export const config = {
  action: giftActions.useGiftError.type,
  method: takeLatest,
};

export function* func(action: giftActions.IEmptyPayload) {
  yield put(giftActions.setOpenGift(false));
  yield put(giftActions.setLoadingGift(false));
  yield put(giftActions.setGiftError(true));
}
